/* RESPONSIBLE TEAM: team-ai-agent */
import type AppService from 'embercom/services/app-service';
import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import type IntlService from 'embercom/services/intl';
import { get } from 'embercom/lib/ajax';
import type AiAgentSetupService from 'embercom/services/ai-agent-setup-service';

export default class FinAIAgentDeployPhoneRoute extends Route {
  @service declare intl: IntlService;
  @service declare appService: AppService;
  @service declare finVoiceConfigService: $TSFixMe;
  @service declare aiAgentSetupService: AiAgentSetupService;

  analytics = {
    section: 'automation',
    place: 'fin-ai-agent.deploy.phone',
  };

  queryParams = {
    tab: {
      refreshModel: true,
    },
  };

  get titleToken() {
    return this.intl.t('ai-agent.deploy.phone');
  }

  async model() {
    this.aiAgentSetupService.channelType = 'phone';
    let isSalesOwned = this.appService.app.isSalesforceContracted;
    let canSetupFinVoicePhoneEasySetup = this.appService.app.canSetupFinVoicePhoneEasySetup;

    let hasExistingNumberConfigurations = false;

    // For self-serve customers, check if they have existing number configurations since that means they used it before.
    if (!isSalesOwned) {
      try {
        hasExistingNumberConfigurations = (
          await get(`/ember/inbox/calling_settings`, {
            app_id: this.appService.app.id,
          })
        )?.has_fin_voice_number_configurations;
      } catch (e) {
        console.error('Failed to fetch number configurations', e);
      }
    }

    let canUsePhoneFinVoiceBeta = isSalesOwned || hasExistingNumberConfigurations;

    return {
      hasSomePhoneFeaturesEnabled: canSetupFinVoicePhoneEasySetup || canUsePhoneFinVoiceBeta,
    };
  }
}
